import React from 'react';
import { connect } from 'react-redux';
import Modal from '../Common/Modal';
import FormGroup from '../Common/FormGroup';
import RadioGroup from '../Common/RadioGroup';
import Input from '../Common/Input';
import { seniority as seniorityOptions, incomeType, incomeTypeStaff, justify_incomes_options } from '../ChatsForm/IncomeUtils';
import Button from '../Common/Button';
import s from './EditIncomeForm.scss';
import { declaredValueCleaveOptions } from '../../../config';


const EditIncomeForm = ({
    income_type,
    category,
    income,
    seniority,
    starting_date,
    loading,
    errors,
    handleChange,
    handleSubmit,
    closeModal,
    is_staff,
    justify_incomes,
}) => (
    <div className={s.container}>
        <Modal showModal closeModal={closeModal} closeOnBlur width="475px" className={s.modal} color="#666">
            <form onSubmit={handleSubmit}>
                <RadioGroup label="Tipo de Ingreso:" errors={errors.income_type} onChange={handleChange}  name="income_type" selected={income_type} income_type={income_type} selectedCategory={category}>
                    {(is_staff) ? incomeTypeStaff : incomeType}
                </RadioGroup>
                <FormGroup label="Ingresos Mensuales (ARS)" errors={errors.income}>
                    <Input name="income" type="tel" value={income} onChange={handleChange} className={s.input} cleaveOptions={declaredValueCleaveOptions} />
                </FormGroup>
                <RadioGroup label="Antigüedad" errors={errors.seniority} onChange={handleChange} name="seniority" selected={Number(seniority)}>
                    {seniorityOptions}
                </RadioGroup>
                <RadioGroup label="¿Puede presentar comprobantes de ingresos?" errors={errors.justify_incomes} onChange={handleChange} name="justify_incomes" selected={justify_incomes}>
                    {justify_incomes_options}
                </RadioGroup>
                {is_staff &&
                    <FormGroup label="Fecha de ingreso" errors={errors.starting_date}>
                        <Input
                            type="date"
                            value={starting_date || ''}
                            name="starting_date"
                            onChange={handleChange}
                        />
                    </FormGroup>
                }
                <Button isLoading={loading}>Guardar</Button>
            </form>
        </Modal>
    </div>
);

const mapStateToProps = ({ user }) => ({ is_staff: !!user.is_staff })
export default connect(mapStateToProps)(EditIncomeForm);
